import { __rest } from "tslib";
import RatingForm from '@components/RatingForm.svelte';
import delegate from 'delegate';
import { getString } from './utils';
const emitter = window.M.theme_soon.events;
function showModal(data) {
    emitter.emit('MODAL_OPEN', data);
}
export function bootstrap() {
    bootstrapRatingModal();
}
function bootstrapRatingModal() {
    delegate(document.body, '[data-component="local_rating"]', 'click', (e) => {
        const contextidElem = e.target.closest('[data-contextid]');
        const data = contextidElem.dataset;
        const contextid = data.contextid ? parseInt(data.contextid, 10) : null;
        const modalId = 'rating-feedback-form';
        if (contextidElem) {
            const props = {
                modalId,
                description: null,
                contextid,
                ratingItems: {
                    comprehensible: {
                        heading: getString('comprehensible', 'local_rating'),
                        description: null,
                        name: 'comprehensible',
                        items: [
                            { num: 1, label: getString('rating_1', 'local_rating') },
                            { num: 2, label: getString('rating_2', 'local_rating') },
                            { num: 3, label: getString('rating_3', 'local_rating') },
                            { num: 4, label: getString('rating_4', 'local_rating') },
                        ]
                    },
                    helpful: {
                        heading: getString('helpful', 'local_rating'),
                        description: null,
                        name: 'helpful',
                        items: [
                            { num: 1, label: getString('rating_1', 'local_rating') },
                            { num: 2, label: getString('rating_2', 'local_rating') },
                            { num: 3, label: getString('rating_3', 'local_rating') },
                            { num: 4, label: getString('rating_4', 'local_rating') },
                        ]
                    }
                },
                commentBlock: {
                    title: getString('comments_heading', 'local_rating'),
                    description: getString('comments_description', 'local_rating')
                }
            };
            showModal({
                content: RatingForm,
                id: modalId,
                size: 'lg',
                async: true,
                asyncPropsFn: async () => {
                    const searchParams = new URLSearchParams({ action: 'get_rating', contextid: `${contextid}` });
                    const response = await fetch(`/local/rating/ajax.php?${searchParams}`);
                    const json = await response.json();
                    if (json.errorcode) {
                        return {
                            title: getString('error', 'moodle'),
                            type: 'html',
                            content: json.error
                        };
                    }
                    else {
                        const { title } = json, props = __rest(json, ["title"]);
                        return {
                            title, props
                        };
                    }
                },
                type: 'component',
                props: Object.assign(Object.assign({}, props), { setRating: async (params) => {
                        const searchParams = new URLSearchParams(Object.assign({ action: 'set_rating', contextid: `${contextid}` }, params));
                        await fetch(`/local/rating/ajax.php?${searchParams}`);
                        emitter.emit(`RATING_SET:${contextid}`, Object.assign({ contextid }, params));
                    } })
            });
        }
        else {
            console.warn('No element with data-contextid attribute found!');
        }
    }, false);
}
